/** Límites alineados con backend/core/upload_limits.py y nginx client_max_body_size 100M */

export const ENTREGA_MAX_ARCHIVOS = 20;
export const ENTREGA_MAX_ARCHIVO_BYTES = 20 * 1024 * 1024;
export const ENTREGA_MAX_ARCHIVO_MB = ENTREGA_MAX_ARCHIVO_BYTES / (1024 * 1024);
export const ENTREGA_MAX_SUBIDA_TOTAL_BYTES = 100 * 1024 * 1024;
export const ENTREGA_MAX_SUBIDA_TOTAL_MB = ENTREGA_MAX_SUBIDA_TOTAL_BYTES / (1024 * 1024);

export const ENTREGA_TEXTO_MAX_CHARS = 200_000;
export const ENTREGA_CODIGO_MAX_CHARS = 200_000;
export const ENTREGA_ENLACE_MAX_CHARS = 2048;

export const AVATAR_MAX_BYTES = 5 * 1024 * 1024;
export const AVATAR_MAX_MB = AVATAR_MAX_BYTES / (1024 * 1024);
export const EDITOR_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
export const EDITOR_IMAGE_MAX_MB = EDITOR_IMAGE_MAX_BYTES / (1024 * 1024);

export const CHAT_MENSAJE_MAX_CHARS = 5000;

export const TAREA_MATERIAL_MAX_ARCHIVOS = 15;
export const TAREA_MATERIAL_MAX_ARCHIVO_BYTES = 20 * 1024 * 1024;
export const TAREA_MATERIAL_MAX_ARCHIVO_MB = TAREA_MATERIAL_MAX_ARCHIVO_BYTES / (1024 * 1024);

export const CALIFICACIONES_PAGE_SIZE = 10;
export const CURSOS_DISPONIBLES_PAGE_SIZE = 30;
